import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Stripe } from '@capacitor-community/stripe';
import { BasePage } from 'src/app/lib/base-page';
import { LoaderService } from 'src/app/services/loader.service';
import { ModalService } from 'src/app/services/modal.service';
import { PaymentsService } from 'src/app/services/payments.service';

@Component({
  selector: 'app-mobility-payment-confirm',
  templateUrl: './mobility-payment-confirm.page.html',
  styleUrls: ['./mobility-payment-confirm.page.scss'],
})
export class MobilityPaymentConfirmPage extends BasePage implements OnInit {
  constructor(
    private payments: PaymentsService,
    private modal: ModalService,
    private loaderService: LoaderService,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {}

  public async confirmPayment(): Promise<void> {
    await this.loaderService.loader();
    try {
      const { data } = await this.payments.setupIntent().toPromise();

      await Stripe.createPaymentFlow({
        setupIntentClientSecret: data.setup_intent,
        customerEphemeralKeySecret: data.ephemeral_key,
        customerId: data.customer,
        merchantDisplayName: 'HerzBegleiter',
      });

      await Stripe.presentPaymentFlow();
      await Stripe.confirmPaymentFlow();

      const response = await this.payments.subscribeWithStripe().toPromise();
      await this.payments.handlePayment('stripe', {
        subscription: response.data.subscription,
      });

      setTimeout(async () => {
        await this.loaderService.dismiss();
        this.modal.showModal(
          'Deine Zahlung war erfolgreich',
          ['Sie können nun auf den Bereich Mobilität zugreifen.'],
          [
            {
              text: 'OK',
              color: 'primary',
              onClick: () => {
                this.modal.dismiss();
                this.router.navigateByUrl('/tabs/mobility');
              },
            },
          ]
        );
      }, 3000);
    } catch (e) {
      await this.loaderService.dismiss();
      this.modal.showModal(
        'Fehler',
        [
          'Beim Bezahlen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
        ],
        [
          {
            text: 'OK',
            color: 'primary',
            onClick: () => {
              this.modal.dismiss();
            },
          },
        ]
      );
    }
  }
}
